import { ContractTypeModel } from 'types/ContractType/ContractTypeModel';
import { Option } from 'types/Form/FormCommons';

export const mapContractTypeToFilterOptions = (contractTypes: ContractTypeModel[]): Option<number>[] =>
  contractTypes.map(({ id, name }) => ({
    label: name,
    value: id,
  }));
